import React from 'react';
import { Section } from './ui/Section';
import { CloudRain, Sun } from 'lucide-react';
export function RealExamples() {
  return <div className="py-20" data-id="element-158">
      <Section data-id="element-159">
        <h2 className="text-3xl md:text-4xl mb-12 text-center" data-id="element-160">
          Cómo se ve en la vida real
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20" data-id="element-161">
          {/* Bad Day Card */}
          <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm relative overflow-hidden" data-id="element-162">
            <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-163">
              <CloudRain size={100} data-id="element-164" />
            </div>
            <h3 className="text-xl font-bold mb-2 text-gray-600" data-id="element-165">Día malo</h3>
            <p className="text-sm text-gray-500 mb-6 uppercase tracking-wider font-semibold" data-id="element-166">
              10 minutos totales
            </p>

            <ul className="space-y-4 relative z-10" data-id="element-167">
              <li className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-168">
                <span className="font-medium" data-id="element-169">Energía</span>
                <span className="text-sm bg-gray-100 px-2 py-1 rounded" data-id="element-170">
                  2 min luz + agua
                </span>
              </li>
              <li className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-171">
                <span className="font-medium" data-id="element-172">Enfoque</span>
                <span className="text-sm bg-gray-100 px-2 py-1 rounded" data-id="element-173">
                  Brain dump 2 min
                </span>
              </li>
              <li className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-174">
                <span className="font-medium" data-id="element-175">Cuerpo</span>
                <span className="text-sm bg-gray-100 px-2 py-1 rounded" data-id="element-176">
                  Caminar 4 min
                </span>
              </li>
              <li className="flex justify-between items-center pb-2" data-id="element-177">
                <span className="font-medium" data-id="element-178">Rumbo</span>
                <span className="text-sm bg-gray-100 px-2 py-1 rounded" data-id="element-179">
                  Una decisión 2 min
                </span>
              </li>
            </ul>
            <div className="mt-6 pt-6 border-t border-gray-100 text-center font-bold text-gray-600" data-id="element-180">
              Listo. Ganaste.
            </div>
          </div>

          {/* Good Day Card */}
          <div className="bg-terracotta text-white rounded-2xl p-8 shadow-xl relative overflow-hidden transform md:-translate-y-4" data-id="element-181">
            <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-182">
              <Sun size={100} data-id="element-183" />
            </div>
            <h3 className="text-xl font-bold mb-2" data-id="element-184">Día bueno</h3>
            <p className="text-sm text-white/80 mb-6 uppercase tracking-wider font-semibold" data-id="element-185">
              25–40 minutos
            </p>

            <div className="space-y-6 relative z-10" data-id="element-186">
              <p className="text-lg" data-id="element-187">Haces 0.1 en 3 pilares...</p>
              <div className="bg-white/10 p-4 rounded-lg backdrop-blur-sm border border-white/20" data-id="element-188">
                <p className="font-medium mb-1" data-id="element-189">...y expandes el dominante</p>
                <p className="text-sm text-white/80" data-id="element-190">
                  Ejemplo: Enfoque con un bloque de 20 min
                </p>
              </div>
              <p className="text-lg font-medium pt-2" data-id="element-191">
                No cambias de plan. <br data-id="element-192" />
                Solo subes potencia.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center max-w-xl mx-auto" data-id="element-193">
          <h2 className="text-3xl md:text-4xl mb-6" data-id="element-194">
            Lo que cambia en 30 días
          </h2>
          <p className="text-xl text-brown/80 mb-8" data-id="element-195">
            No vas a "renacer". Vas a conseguir algo más raro:
          </p>
          <div className="text-2xl font-serif font-bold text-terracotta space-y-2" data-id="element-196">
            <p data-id="element-197">Estabilidad sin drama.</p>
            <p data-id="element-198">Menos culpa.</p>
            <p data-id="element-199">Más piso.</p>
          </div>
        </div>
      </Section>
    </div>;
}